import { render, staticRenderFns } from "./_BackupTacticsList.vue?vue&type=template&id=09230756&scoped=true"
import script from "./_BackupTacticsList.vue?vue&type=script&lang=ts"
export * from "./_BackupTacticsList.vue?vue&type=script&lang=ts"
import style0 from "./_BackupTacticsList.vue?vue&type=style&index=0&id=09230756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09230756",
  null
  
)

export default component.exports